import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M21 2v6h-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 13a9 9 0 1 1-3-7.7L21 8", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "RotateCw";
const RotateCw = memo(themed(Icon));
export {
  RotateCw
};
//# sourceMappingURL=rotate-cw.js.map
